<template>
  <div ref="mapContainer" style="height: 400px; width: 100%;"></div>
</template>

<script>
export default {
  name: 'GoogleMapsPicker',
  data() {
    // พิกัดมหาวิทยาลัยแม่ฟ้าหลวง (MFU)
    const MFU_LAT = 20.04502266214119; 
    const MFU_LNG = 99.89483339570916; 

    return {
      map: null,
      marker: null,
      // 1. จุดศูนย์กลางของแผนที่ (เริ่มต้นที่ MFU)
      mapCenter: { lat: MFU_LAT, lng: MFU_LNG },
      // 2. ตำแหน่งหมุดปัจจุบัน (เริ่มต้นที่ MFU)
      currentMarker: { lat: MFU_LAT, lng: MFU_LNG },
    };
  },
  mounted() {
    this.initMap();
    // ส่งค่าเริ่มต้นออกไปให้ Parent Component ทันทีที่โหลดเสร็จ
    this.emitLocation(this.currentMarker);
  },
  beforeDestroy() {
    if (this.map) {
      // Google Maps ไม่มี remove method เหมือน Leaflet
      // แต่เราสามารถล้าง reference ได้
      this.map = null;
      this.marker = null;
    }
  },
  methods: {
    initMap() {
      // ตรวจสอบว่า Google Maps API โหลดแล้วหรือยัง
      if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
        console.error('Google Maps API is not loaded. Please check script tag in index.html');
        // รอให้ Google Maps โหลดเสร็จ
        setTimeout(() => this.initMap(), 100);
        return;
      }

      // สร้างแผนที่ Google Maps
      this.map = new google.maps.Map(this.$refs.mapContainer, {
        center: this.mapCenter,
        zoom: 15,
        mapTypeId: google.maps.MapTypeId.HYBRID
      });

      // สร้าง marker ที่สามารถลากได้
      this.marker = new google.maps.Marker({
        position: this.mapCenter,
        map: this.map,
        draggable: true,
        title: 'ตำแหน่งที่เลือก'
      });

      // อัปเดตตำแหน่งเมื่อลาก marker
      this.marker.addListener('dragend', (event) => {
        const position = this.marker.getPosition();
        this.currentMarker = {
          lat: position.lat(),
          lng: position.lng()
        };
        this.emitLocation(this.currentMarker);
      });

      // อัปเดตตำแหน่งเมื่อคลิกบนแผนที่
      this.map.addListener('click', (event) => {
        const lat = event.latLng.lat();
        const lng = event.latLng.lng();
        this.currentMarker = { lat, lng };
        this.marker.setPosition({ lat, lng });
        this.emitLocation(this.currentMarker);
      });
    },

    // ส่งค่าพิกัดไปยัง Parent Component (ใช้ Event @input เพื่อรองรับ v-model)
    emitLocation(location) {
      this.$emit('input', {
        lat: location.lat,
        lng: location.lng
      });
    }
  }
};
</script>

<style scoped>
/* Google Maps map container styles */
:deep(.gm-style) {
  height: 100%;
  width: 100%;
  z-index: 0;
}
</style>
